<template>
  <div class="modal">
    <modal :name="modalName">
      <div class="modal__header">
        <slot name="header"></slot>
      </div>
      <div class="modal__body">
        <slot name="body"></slot>
      </div>
      <div class="modal__footer">
        <slot name="footer"></slot>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "v-modal",

  props: {
    modalName: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="sass" scoped>

.modal
  font-size: 13px
  background: $c-white
  margin: 0 auto

  &__header
    font:
      size: 20px
      weight: 300
    margin-bottom: 20px

  &__body
    display: flex
    justify-content: space-around

input, textarea
  width: 350px
  height: 40px
  border-radius: 10px
  background-color: $c-white
  border: 1px solid $c-gray
  text-indent: 15px
  

</style>